import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetActiveAfterEffectsEntitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveAfterEffectsEntitiesQuery = { __typename?: 'Query', activeAfterEffectsProject?: { __typename?: 'AfterEffectsProject', id?: string | null, name?: string | null } | null, activeComposition?: { __typename?: 'AfterEffectsComposition', id?: string | null, name?: string | null } | null };


export const GetActiveAfterEffectsEntities = /*#__PURE__*/ gql`
    query GetActiveAfterEffectsEntities {
  activeAfterEffectsProject {
    id
    name
  }
  activeComposition {
    id
    name
  }
}
    ` as unknown as DocumentNode<GetActiveAfterEffectsEntitiesQuery, GetActiveAfterEffectsEntitiesQueryVariables>;

          

          export const useGetActiveAfterEffectsEntitiesQuery = (options?:QueryHookOptions<GetActiveAfterEffectsEntitiesQuery, GetActiveAfterEffectsEntitiesQueryVariables>) => useQuery(GetActiveAfterEffectsEntities, options);

          

          export type GetActiveAfterEffectsEntitiesQueryOptions = QueryHookOptions<GetActiveAfterEffectsEntitiesQuery, GetActiveAfterEffectsEntitiesQueryVariables>;

          

          export const useGetActiveAfterEffectsEntitiesLazyQuery = (options?:LazyQueryHookOptions<GetActiveAfterEffectsEntitiesQuery, GetActiveAfterEffectsEntitiesQueryVariables>) => useLazyQuery(GetActiveAfterEffectsEntities, options);

          

          export type GetActiveAfterEffectsEntitiesQueryResult = ReturnType<typeof useGetActiveAfterEffectsEntitiesQuery>;

          
